import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLeading } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

export interface EncerrarManifestacaoRequest {
  idManifestacao: string;
  nota: number;
  onSuccess?: () => void;
  onError?: () => void;
}

interface State {
  isRequesting: boolean;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  errors: []
};

const slice = createSlice({
  name: "ouvidoria.manifestacoes@encerrarManifestacao",
  initialState,
  reducers: {
    encerrarManifestacao: (
      state,
      _action: PayloadAction<EncerrarManifestacaoRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    encerrarManifestacaoSuccess: (state): void => {
      state.isRequesting = false;
    },
    encerrarManifestacaoFailed: (
      state,
      action: PayloadAction<string[]>
    ): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* worker(params: {
  type: string;
  payload: EncerrarManifestacaoRequest;
}) {
  const { idManifestacao, nota, onSuccess, onError } = params.payload;

  const formData = new FormData();
  if (nota) {
    formData.append("nota", nota.toString());
  }

  try {
    yield call(
      api.put,
      `api/v1/cidadao/ouvidoria/manifestacoes/encerrar/${idManifestacao}`,
      formData,
      { headers: { "content-type": "multipart/form-data" } }
    );
    yield put(encerrarManifestacaoSuccess());
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(encerrarManifestacaoFailed(formatError(error)));
    if (onError) onError();
  }
}

export const {
  encerrarManifestacao,
  encerrarManifestacaoSuccess,
  encerrarManifestacaoFailed
} = slice.actions;
export const { reducer } = slice;
export const saga = takeLeading(encerrarManifestacao.type, worker);
